/**
 * Admin System Metrics page — detailed system-wide analytics.
 */

import React, { useEffect, useState } from 'react';
import { getSystemMetrics, AdminMetrics } from '../../services/admin.service';
import { AlertCircle, RefreshCw, Database, Users, Key, Coins } from 'lucide-react';

export default function AdminMetricsPage() {
  const [metrics, setMetrics] = useState<AdminMetrics | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = () => {
    setLoading(true);
    setError('');
    getSystemMetrics()
      .then(setMetrics)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  if (loading && !metrics) {
    return <div className="page-loader">Loading system metrics…</div>;
  }

  return (
    <div className="dashboard-page">
      <div className="page-header">
        <div>
          <h1>System Metrics</h1>
          <p>Platform-wide statistics</p>
        </div>
        <button className="btn btn-ghost" onClick={load} disabled={loading}>
          <RefreshCw size={16} className={loading ? 'spin' : ''} /> Refresh
        </button>
      </div>

      {error && (
        <div className="alert alert-error">
          <AlertCircle size={16} /> {error}
        </div>
      )}

      {metrics && (
        <>
          <div className="metrics-grid">
            <div className="metric-card">
              <div className="metric-icon"><Users size={24} /></div>
              <div className="metric-value">{metrics.totalDevelopers.toLocaleString()}</div>
              <div className="metric-label">Developers</div>
            </div>
            <div className="metric-card">
              <div className="metric-icon"><Users size={24} /></div>
              <div className="metric-value">{metrics.totalUsers.toLocaleString()}</div>
              <div className="metric-label">End Users</div>
            </div>
            <div className="metric-card">
              <div className="metric-icon"><Key size={24} /></div>
              <div className="metric-value">{metrics.totalApiKeys.toLocaleString()}</div>
              <div className="metric-label">API Keys</div>
            </div>
            <div className="metric-card">
              <div className="metric-icon"><Coins size={24} /></div>
              <div className="metric-value">{metrics.totalUserTokens.toLocaleString()}</div>
              <div className="metric-label">User Tokens</div>
            </div>
          </div>

          <div className="section-card" style={{ marginTop: '24px' }}>
            <h3><Database size={18} /> DynamoDB Tables</h3>
            <div className="table-container">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Resource</th>
                  <th style={{ textAlign: 'right' }}>Count</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>Developer accounts</td><td style={{ textAlign: 'right' }}>{metrics.totalDevelopers}</td></tr>
                <tr><td>End users</td><td style={{ textAlign: 'right' }}>{metrics.totalUsers}</td></tr>
                <tr><td>Active API keys</td><td style={{ textAlign: 'right' }}>{metrics.totalApiKeys}</td></tr>
                <tr><td>User tokens</td><td style={{ textAlign: 'right' }}>{metrics.totalUserTokens}</td></tr>
              </tbody>
            </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
